import PropTypes from 'prop-types';
import React     from 'react';

import { CancelARPresenter } from './cancel-ar-presenter';
import { useCancelAr }       from '../../../helpers/hooks/use-cancel-ar';

const CancelAR = ({onClose, ctx: {product}}) => {
  const CANCEL_AR = useCancelAr(product, onClose);
  const IS_BM     = product === 'billmanager';

  const MESSAGE = `Once your membership expires, you will no longer
    ${product === 'billmanager'
    ? ' be able to schedule Quick Pay & Check Pay payments from your Quicken application'
    : ' have the convenience of Quicken connected services including:'}`;

  const POINTS = IS_BM ? [] : [
    'Bank Downloads',
    'Free Phone Support',
    'Stock Price Updates',
    'Regular Updates, Fixes, and Improvements',
    'Account Sync'
  ];


  return (
    <CancelARPresenter
      product={product}
      message={MESSAGE}
      points={POINTS}
      onClose={onClose}
      onSubmit={CANCEL_AR}
    />
  );
};

CancelAR.displayName = 'CancelAR';
CancelAR.propTypes   = {
  onClose: PropTypes.func.isRequired,
  ctx:     PropTypes.shape({
    product: PropTypes.string.isRequired
  })
};

export { CancelAR };
